export function generateSessionUrl(sessionId, includeHost = false) {
  const prefix = includeHost ? 'https://virti.us' : '';
  return `${prefix}/session?s=${sessionId}`;
}
